var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContextMenuAFY, icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
export var columnsFn = function (handleClickContextMenu) {
    var columns = [
        {
            field: "actions",
            headerName: "Acciones",
            width: 150,
            renderCell: function (params) {
                var menuContext = [
                    {
                        disabled: false,
                        icon: {
                            color: "#006ac6",
                            icon: icons.Search,
                            size: sizesIcon.standard,
                        },
                        id: "1",
                        name: "Ver detalles",
                    },
                ];
                return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: menuContext, onClickContextMenu: function (item) {
                            return handleClickContextMenu(item, params);
                        }, sizeIcon: sizesIcon.standard }) })));
            },
        },
        {
            editable: false,
            field: "status",
            headerName: "Estado",
            renderCell: function (params) { return (_jsxs("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: [_jsx("span", { className: params.value }), params.value] }))); },
            width: 150,
        },
        {
            field: "quotation",
            headerName: "Cotización",
            width: 200,
        },
        {
            field: "certificate",
            headerName: "No. Póliza",
            width: 200,
        },
        {
            field: "names",
            headerName: "Nombres",
            width: 300,
        },
        {
            field: "lastNames",
            headerName: "Apellidos",
            width: 300,
        },
    ];
    return columns;
};
export var DataCards = [
    {
        id: "1",
        numericalTitle: "",
        title: "Total pólizas pendientes",
    },
    {
        id: "2",
        numericalTitle: "",
        title: "Total pólizas completadas",
    },
];
